import React from 'react';
import SkillCard from './SkillCard';
function Skills() {
    return(
        <div className="skills">
                        <p id="tech">Programming Languages</p>
                        <div className="programmingLanguages">
                            <SkillCard skill="C++" level="Intermediate"/>
                            <SkillCard skill="C" level="Intermediate"/>
                            <SkillCard skill="Java" level="Intermediate"/>
                            <SkillCard skill="Python" level="Beginner"/>
                            <SkillCard skill="Dart" level="Beginner"/>

                        </div>
                        <p id="tech">Web Development</p>
                        <div className="webTechnology">
                            <SkillCard skill="HTML" level="Advance"/>
                            <SkillCard skill="CSS" level="Advance"/>
                            <SkillCard skill="JavaScript" level="Intermediate"/>
                            <SkillCard skill="PHP" level="Intermediate"/>
                            <SkillCard skill="MySQL" level="Beginner"/>
                            <SkillCard skill="Django" level="Begineer"/>
                            <SkillCard skill="React" level="Begineer"/>
                            
                        </div>
                        <p id="tech">Mobile Development</p>
                        <div className="mobile">
                            <SkillCard skill="Flutter" level="Begineer"/>
                        </div>
                    </div>
    );
}

export default Skills;